import {
  LAYOUT_EMPTY,
  LAYOUT_PUBLIC,
  GLOBAL_PREFIX,
} from '@/router/constants';

// Cluster D: de publieke community-pagina's uit ui-v1.
const publicPage = (path, name, component, meta = {}) => ({
  path: `${GLOBAL_PREFIX}${path}`,
  name,
  component,
  meta: {
    app: 'public',
    layout: LAYOUT_PUBLIC,
    anonymousAllowed: true,
    ...meta,
  },
});

const routes = [
  {
    path: `${GLOBAL_PREFIX}/partners`,
    name: 'public-partners',
    component: () => import('@/views/public/PartnerListView.vue'),
    meta: {
      title: 'word.partners',
      app: 'public',
      layout: LAYOUT_EMPTY,
      anonymousAllowed: true,
      hideBreadcrumbs: true,
    },
  },
  {
    // De voordeur van ui-v1, die op rol doorstuurt. Alleen binnen de app: de knop
    // van `common-success` gaat hierheen. Bij een volledige paginalading komt `/`
    // bij de backend binnen, die naar `/ui/v2/` (`common-home`) doorstuurt.
    path: '/',
    name: 'public-home-redirect',
    component: () => import('@/views/public/HomeRedirectView.vue'),
    meta: {
      app: 'public',
      layout: LAYOUT_EMPTY,
      anonymousAllowed: true,
      hideBreadcrumbs: true,
    },
  },
  {
    // Cluster A route #3. Geen scherm maar een pass-through; zie §9c-1.
    path: `${GLOBAL_PREFIX}/activate/:uuid`,
    name: 'public-activate-account',
    component: () => import('@/views/public/ActivateAccountView.vue'),
    meta: {
      app: 'public',
      layout: LAYOUT_EMPTY,
      anonymousAllowed: true,
      hideBreadcrumbs: true,
    },
  },
  {
    // Cluster A route #4. Ook een pass-through, maar wel achter inloggen.
    path: `${GLOBAL_PREFIX}/email-change/:uuid/confirm`,
    name: 'public-email-change-confirm',
    component: () => import('@/views/public/EmailChangeConfirmView.vue'),
    meta: {
      app: 'public',
      layout: LAYOUT_EMPTY,
      hideBreadcrumbs: true,
    },
  },
  publicPage('/research-set/:uuid', 'public-research-set',
    () => import('@/views/public/ResearchSetView.vue')),
  // Het beginpunt van de reviewersomgeving: in de sidebar licht "Dashboard"
  // op, zoals "Mijn coins" op zijn eigen pagina.
  publicPage('/dashboard', 'public-dashboard',
    () => import('@/views/public/DashboardView.vue'),
    { navRouteActive: 'public-dashboard' }),
  publicPage('/organisations', 'public-organisation-list',
    () => import('@/views/public/OrganisationListView.vue')),
  {
    // De parameter is de uuid van de organisatie, net als in ui-v1 sinds
    // #1014.
    //
    // Onder `/ui/v2/organisation/` alléén met een uuid: die namespace is van de
    // klantomgeving, en een vrije parameter daar zou elk vast segment
    // overschaduwen (`detail`, `chat`, ...). Zie §10b. De backend stuurt het
    // oude `/organisation/<uuid>/` hierheen, en een oude link met de slug naar
    // de lijst (#1068).
    //
    // De links in ui-v2 gaan op deze naam, dus naar het `/ui/v2`-pad: dat blijft
    // ook na herladen of delen in ui-v2.
    path: `${GLOBAL_PREFIX}/organisation/:organisation([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})`,
    name: 'public-organisation-detail',
    component: () => import('@/views/public/OrganisationDetailView.vue'),
    meta: {
      app: 'public',
      layout: LAYOUT_PUBLIC,
      anonymousAllowed: true,
    },
  },
  publicPage('/all-commercials', 'public-commercial-list',
    () => import('@/views/public/CommercialListView.vue'),
    { navRouteActive: 'public-commercial-list' }),
  publicPage('/articles', 'public-article-list',
    () => import('@/views/public/ArticleListView.vue')),
  publicPage('/articles/:slug', 'public-article-detail',
    () => import('@/views/public/ArticleDetailView.vue')),
];

export default routes;
